import { classifyAssistantError } from './error-codes'
import type { AssistantStepType } from './types'

export interface AssistantFallbackDecision {
  action: 'fail' | 'skip-step'
  logMessage?: string
}

function getErrorMessage(error: unknown): string | null {
  if (!(error instanceof Error)) {
    return null
  }

  const message = error.message.trim()
  return message ? message : null
}

export function getAssistantFallbackDecision(
  stepType: AssistantStepType,
  error: unknown,
): AssistantFallbackDecision {
  const code = classifyAssistantError(error, { stepType })
  const errorMessage = getErrorMessage(error)

  switch (code) {
    case 'ASSISTANT_REFERENCE_IMAGE_GENERATION_FAILED':
      return {
        action: 'skip-step',
        logMessage: errorMessage
          ? `Reference image generation failed: ${errorMessage}. The assistant will continue without generated visuals.`
          : 'Reference image generation failed. The assistant will continue without generated visuals.',
      }
    case 'ASSISTANT_BGM_GENERATION_FAILED':
      return {
        action: 'skip-step',
        logMessage: 'Background music generation failed. The assistant will continue without BGM.',
      }
    case 'ASSISTANT_EXPORT_FAILED':
    case 'ASSISTANT_EXPORT_UNSUPPORTED':
      return {
        action: 'skip-step',
        logMessage: 'Draft export failed. The current timeline draft has been preserved for manual export.',
      }
    default:
      return { action: 'fail' }
  }
}